import React, { useContext, useRef } from "react";
import { AppContext } from "../App";
import api from "./api/api";
import SearchIcon from "../icons/SearchIcon";

export default function QrScanPopup() {
    const { setQrScanPopupVisible, openOrder, orders, selectCustomer, setConfirm } = useContext(AppContext);
    const orderId = useRef();

    async function handleSrc(e) {
        e.preventDefault();
        const code = orderId.current.value.trim();
        document.getElementById("qrForm").reset();

        if (code.toLowerCase().startsWith("c")) {
            const customerId = code.substring(1);
            const res = await api.getProtected("/customers/get/" + customerId + "/");
            if (res.success == 0 || !res.data) {
                setConfirm({ title: "Errore", message: "Cliente non trovato" });
            } else {
                selectCustomer(res.data);
                setQrScanPopupVisible(false);
            }
        } else {
            const res = orders.filter((o) => o.id == code);
            if (res.length > 0) {
                openOrder(res[0]);
                setQrScanPopupVisible(false);
            } else {
                setConfirm({ title: "Errore", message: "Ordine non trovato" });
            }
        }
    }

    return (
        <div className="qr-popup">
            <div className="qr-popup-container">
                <header>
                    <div className="buttons-group">
                        <button className="qr-popup-close" onClick={() => setQrScanPopupVisible(false)}>
                            &times;
                        </button>
                        <div>
                            <div>Ricerca Ordine/Cliente</div>
                        </div>
                    </div>
                </header>
                <div className="content qr-code-container">
                    <form id="qrForm" onSubmit={handleSrc} autoComplete="off" style={{ display: "flex", gap: "6px" }}>
                        <input
                            id="qrFormField"
                            type="text"
                            ref={orderId}
                            autoFocus={true}
                            autoComplete="do-not-autofill"
                            inputMode="text"
                            style={{ flex: 1, width: "auto", minWidth: 0, textAlign: "left" }}
                            onBlur={() => document.getElementById("qrFormField").focus()}
                        />
                        <button
                            type="submit"
                            className="button square"
                            style={{ width: "44px", height: "44px" }}
                            onMouseDown={(e) => e.preventDefault()}
                        >
                            <SearchIcon />
                        </button>
                    </form>
                    <div className="qr-info" style={{ fontSize: "0.75rem", color: "#999", marginTop: "8px", textAlign: "left" }}>
                        <p style={{ margin: "2px 0" }}>
                            Cliente: scansiona QR oppure digita ID cliente: <strong>c123</strong>
                        </p>
                        <p style={{ margin: "2px 0" }}>
                            Ordine: scansiona QR oppure digita ID ordine: <strong>123</strong>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}
